<template>
  <sf-button
    tag="router-link"
    :to="linker.specialOrdersDetails(specialOrder)"
    role="button"
  >
    {{ $t("Special order") }}
  </sf-button>
</template>

<script setup lang="ts">
import { useLinker } from "~/composables";
import { StrapiSpecialOrders } from "~/types/strapi";

defineProps<{ specialOrder: Pick<StrapiSpecialOrders, "slug"> }>();

const linker = useLinker();
</script>
